var map = {
	"./clean.svg": 27435,
	"./delete.svg": 30129,
	"./edit.svg": 71452,
	"./link.svg": 64024,
	"./preview.svg": 95180,
	"./refresh.svg": 86065,
	"./rotate.svg": 77605
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30279;